import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import API from '../services/api';

export default function Dashboard() {
  const { usuario } = useAuth();
  const navigate = useNavigate();
  const [datos, setDatos] = useState(null);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    API.get('/dashboard').then(res => {
      setDatos(res.data);
      setCargando(false);
    }).catch(() => setCargando(false));
  }, []);

  const hora = new Date().getHours();
  const saludo = hora < 13 ? 'Buenos días' : hora < 20 ? 'Buenas tardes' : 'Buenas noches';
  const nombreCorto = usuario?.nombre?.split(' ')[0] || '';

  if (cargando) return <div style={styles.loading}>Cargando...</div>;

  return (
    <div style={styles.page}>
      <div style={styles.topbar}>
        <div style={styles.topbarTitle}>{saludo}, {nombreCorto}</div>
        <div style={styles.fecha}>{new Date().toLocaleDateString('es-ES', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })}</div>
      </div>

      <div style={styles.content}>
        <div style={styles.metrics}>
          <div style={styles.metric}>
            <div style={styles.metricLabel}>Empleados activos</div>
            <div style={styles.metricValue}>{datos?.total_empleados ?? 0}</div>
          </div>
          <div style={styles.metric}>
            <div style={styles.metricLabel}>Fichajes hoy</div>
            <div style={styles.metricValue}>{datos?.fichajes_hoy ?? 0}</div>
          </div>
          <div style={styles.metric}>
            <div style={styles.metricLabel}>Proyectos activos</div>
            <div style={styles.metricValue}>{datos?.proyectos_activos ?? 0}</div>
          </div>

        </div>

        <div style={styles.card}>
          <div style={styles.cardHeader}>
            <span style={styles.cardTitle}>Proyectos activos</span>
            <span style={styles.cardAction} onClick={() => navigate('/proyectos')}>Ver todos →</span>
          </div>
          {datos?.proyectos?.filter(p => p.estado === 'activo').length === 0 ? (
            <div style={styles.empty}>
              <div style={styles.emptyText}>No hay proyectos activos</div>
              <button style={styles.emptyBtn} onClick={() => navigate('/proyectos/nuevo')}>Crear proyecto</button>
            </div>
          ) : (
            <table style={{width:'100%',borderCollapse:'collapse'}}>
              <thead>
                <tr>
                  <th style={styles.th}>Proyecto</th>
                  <th style={styles.th}>Cliente</th>
                  <th style={styles.th}>Horas imputadas</th>
                  <th style={styles.th}>Fecha fin</th>
                  <th style={styles.th}>Estado</th>
                </tr>
              </thead>
              <tbody>
                {datos?.proyectos?.filter(p => p.estado === 'activo').map(p => (
                  <tr key={p.id} style={styles.projRow} onClick={() => navigate(`/proyectos/${p.id}`)}>
                    <td style={styles.td}><span style={styles.projName}>{p.nombre}</span></td>
                    <td style={styles.td}><span style={styles.projClient}>{p.cliente || '—'}</span></td>
                    <td style={styles.td}><span style={{fontWeight:600,color:'#378ADD'}}>{p.total_horas > 0 ? `${p.total_horas}h` : '0h'}</span></td>
                    <td style={styles.td}><span style={styles.projClient}>{p.fecha_fin ? new Date(p.fecha_fin).toLocaleDateString('es-ES',{day:'2-digit',month:'2-digit',year:'numeric'}) : '—'}</span></td>
                    <td style={styles.td}><span style={{...styles.pill, ...styles.pillActive}}>Activo</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
}

const styles = {
  page: { display: 'flex', flexDirection: 'column', minHeight: '100vh', background: '#f5f5f3' },
  loading: { display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', color: '#aaa', fontSize: 14 },
  topbar: { background: 'white', borderBottom: '0.5px solid #e0e0d8', padding: '0 24px', height: 48, display: 'flex', alignItems: 'center', justifyContent: 'space-between' },
  topbarTitle: { fontSize: 14, fontWeight: 500, color: '#1a1a1a' },
  fecha: { fontSize: 12, color: '#aaa', textTransform: 'capitalize' },
  content: { padding: 24 },
  metrics: { display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 12, marginBottom: 20 },
  metric: { background: '#f0f0ed', borderRadius: 8, padding: '14px 16px' },
  metricWarn: { background: '#FAEEDA' },
  metricLabel: { fontSize: 12, color: '#888', marginBottom: 6 },
  metricValue: { fontSize: 22, fontWeight: 500, color: '#1a1a1a' },
  card: { background: 'white', border: '0.5px solid #e0e0d8', borderRadius: 12, padding: 16, marginBottom: 16 },
  cardHeader: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 },
  cardTitle: { fontSize: 13, fontWeight: 500, color: '#1a1a1a' },
  cardAction: { fontSize: 12, color: '#378ADD', cursor: 'pointer' },
  projRow: { borderBottom: '0.5px solid #f0f0ed', cursor: 'pointer' },
  projName: { fontSize: 13, color: '#1a1a1a', fontWeight: 500 },
  projClient: { fontSize: 11, color: '#aaa' },
  pill: { fontSize: 11, padding: '2px 8px', borderRadius: 10, fontWeight: 500 },
  pillActive: { background: '#EAF3DE', color: '#3B6D11' },
  th: { padding: '8px 4px', fontSize: 11, fontWeight: 500, color: '#aaa', textAlign: 'left', borderBottom: '0.5px solid #f0f0ed', textTransform: 'uppercase', letterSpacing: '0.05em' },
  td: { padding: '10px 4px', fontSize: 13, color: '#1a1a1a', verticalAlign: 'middle' },
  empty: { textAlign: 'center', padding: '32px 0' },
  emptyText: { fontSize: 14, color: '#aaa', marginBottom: 12 },
  emptyBtn: { background: '#378ADD', color: 'white', border: 'none', borderRadius: 8, padding: '8px 16px', fontSize: 13, cursor: 'pointer' },
};
